import React from "react";
import { Link } from "react-router-dom";
import {
    Button,
    Typography,
    Select,
    MenuItem,
    TextField,
    IconButton,
} from "@material-ui/core";
import { formatDate, parseDate } from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { Search as SearchIcon, Close as RemoveIcon } from "@material-ui/icons";
import { selectViewType } from "./selectors";

import { setViewType } from "./actions";
import styled from "styled-components";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

const ControlGrid = styled.div`
    display: grid;
    grid-template-rows: 1;
    grid-template-columns: 120px 0.5fr 0.9fr 0.9fr 0.9fr 105px 150px;
    padding-top: 10px;
    padding-bottom: 10px;
    align-items: center;
    justify-items: center;
    grid-column-gap: 10px;
    z-index: 999;
`;

const ControlGridItem = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: ${(props) => props.column};
    grid-column-end: ${(props) => props.column};
`;

const StyledTextField = styled(TextField)`
    z-index: 999;
    && {
        width: 100%;
    }
`;

const getDateInputField = (label, disableButton) => {
    return class DateInputField extends React.Component {
        render() {
            const onClick = disableButton.disabled
                ? { onClick: () => {} }
                : null;

            return (
                <StyledTextField
                    label={label}
                    {...this.props}
                    {...disableButton}
                    {...onClick}
                />
            );
        }
    };
};

class JobPackControlsClass extends React.Component {
    render() {
        const {
            setJobMonth,
            month,
            setJobYear,
            year,
            setSearchVal,
            searchVal,

            dateFrom,
            setDateFrom,
            dateTo,
            setDateTo,
            setDayFrom,
            day,
            match,
            status,
            templates,
            template,
            setTemplate,
            setJobUrn,
            jobURN
        } = this.props;
        const viewType = match.url.split("/")[2];
        const disableButton = {
            disabled: viewType === "roster",
        };

        return (
            <>
                <ControlGrid style={{ marginRight: "399px" }}>
                    <ControlGridItem column={1}>
                        <Link
                            to={`/job-pack-create/jobpacks/active/year/month/uid`}
                        >
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                style={{
                                    background: "#0188cc",
                                }}
                            >
                                <Typography
                                    style={{
                                        color: "white",
                                    }}
                                >
                                    New Jobpack
                                </Typography>
                            </Button>
                        </Link>
                    </ControlGridItem>
                    <ControlGridItem column={2}>
                        <TextField
                            onChange={(event) => {
                                setSearchVal(event.target.value);
                            }}
                            style={{ minWidth: 225 }}
                            value={searchVal}
                            label="Search Jobpacks"
                            {...disableButton}
                        />
                    </ControlGridItem>

                    <ControlGridItem column={5}>
                        <DayPickerInput
                            value={dateFrom === false ? "" : dateFrom}
                            placeholder="Start Day"
                            format="DD-MM-YYYY"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={(day) => {
                                setDateFrom(day);
                            }}
                            style={{ zIndex: 900, width: 130 }}
                            component={getDateInputField(
                                "Start Day",
                                disableButton
                            )}
                        />
                    </ControlGridItem>
                    <ControlGridItem column={6}>
                        <DayPickerInput
                            value={dateTo === false ? "" : dateTo}
                            placeholder="End Day"
                            format="DD-MM-YYYY"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={(day) => {
                                setDateTo(day);
                            }}
                            style={{ zIndex: 900, width: 130 }}
                            component={getDateInputField(
                                "End Day",
                                disableButton
                            )}
                        />
                    </ControlGridItem>
                    <ControlGridItem column={7}>
                        <IconButton
                            size="small"
                            style={{ color: "red", border: "red" }}
                            variant="outlined"
                            onClick={() => {
                                setDateFrom();
                                setDateTo();
                            }}
                        >
                            <RemoveIcon />
                        </IconButton>
                    </ControlGridItem>
                    <ControlGridItem column={3}>
                        <TextField
                            onChange={(event) => {
                                if (
                                    event.target.value.length <= 4 &&
                                    !Number.isNaN(Number(event.target.value))
                                )
                                    setJobYear(event.target.value);
                            }}
                            style={{ minWidth: 225 }}
                            value={year}
                            label="Search Jobpacks by Year"
                            {...disableButton}
                        />
                    </ControlGridItem>
                    <ControlGridItem column={4} style={{ display: "flex" }}>
                        <Select
                            id="month"
                            value={month}
                            style={{
                                minWidth: 200,
                                paddingBottom: "16px",
                                textAlign: "center",
                            }}
                            onChange={(event) => {
                                setJobMonth(event.target.value);
                            }}
                        >
                            <MenuItem value="select">Select Month</MenuItem>
                            <MenuItem value="jan">January</MenuItem>
                            <MenuItem value="feb">February </MenuItem>
                            <MenuItem value="mar">March</MenuItem>
                            <MenuItem value="apr">April</MenuItem>
                            <MenuItem value="may">May</MenuItem>
                            <MenuItem value="jun">June</MenuItem>
                            <MenuItem value="jul">July</MenuItem>
                            <MenuItem value="aug">August</MenuItem>
                            <MenuItem value="sep">September</MenuItem>
                            <MenuItem value="oct">October</MenuItem>
                            <MenuItem value="nov">November</MenuItem>
                            <MenuItem value="dec">December</MenuItem>
                        </Select>
                        &nbsp;&nbsp;
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            style={{ background: "#0188cc" }}
                            onClick={() => {
                                this.props.getJobPacks2(status, year, month);
                            }}
                        >
                            <SearchIcon />
                        </Button>
                    </ControlGridItem>
                    <ControlGridItem column={8} style={{ display: "flex" }}>
                        <DayPickerInput
                            value={day === false ? "" : day}
                            placeholder="Filter By Day"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            format="DD-MM-YYYY"
                            style={{ zIndex: 900, width: 130 }}
                            component={getDateInputField(
                                "Filter By Day",
                                disableButton
                            )}
                            onDayChange={(dat) => setDayFrom(dat)}
                        />
                        <IconButton
                            style={{
                                // marginLeft: "5px",
                                // marginTop: "-8px",
                                color: "red",
                                border: "red",
                            }}
                            // style={{ color: "red", border: "1px solid red" }}
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                setDayFrom(false);
                            }}
                        >
                            <RemoveIcon />
                        </IconButton>
                    </ControlGridItem>
                
                </ControlGrid>
                <ControlGrid style={{ marginRight: "399px" }}>
                <ControlGridItem column={2} style={{ display: "flex" }}>
                    
                        <Select
                            value={template}
                            onChange={(event) =>
                                setTemplate(event.target.value)
                            }
                        >
                            <MenuItem value={false}>Select Templates</MenuItem>
                            {templates &&
                                Object.values(templates).map((e) => {
                                    return (
                                        <MenuItem value={e.title} key={e}>
                                            {e.title}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </ControlGridItem>
                    <ControlGridItem column={3} style={{ display: "flex" }}>
                    <TextField
                            onChange={(event) => {
                                setJobUrn(event.target.value);
                            }}
                            style={{ minWidth: 225, marginTop:"-15px" }}
                            value={jobURN}
                            label="Search Jobpack URN"
                            {...disableButton}
                        />
                    </ControlGridItem>
                   
                </ControlGrid>
                {/*<ControlGrid style={{ marginRight: "399px" }}>
                 <ControlGridItem column={2}>
                       
                    </ControlGridItem>
                    </ControlGrid> */}
            </>
        );
    }
}

export const JobPackControls = hot(module)(
    connect(
        (store) => {
            return {
                viewType: selectViewType(store),
            };
        },
        {
            setViewType,
        }
    )(JobPackControlsClass)
);
